function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import { styled } from '@mui/material/styles';
import { bool, string } from 'prop-types';
import clsx from 'clsx';
import SovosChipFilter from '../sovos-chip-filter';
const StyledChip = styled(SovosChipFilter)(_ref => {
  let {
    theme: {
      spacing
    }
  } = _ref;
  return {
    marginInlineStart: spacing(0.5),
    marginInlineEnd: spacing(0.5)
  };
});

/**
 * **Note**: must be a child of `SovosToolbarToggles`
 */
const SovosToolbarToggle = _ref2 => {
  let {
    className,
    selected = false,
    ...props
  } = _ref2;
  return /*#__PURE__*/React.createElement(StyledChip, _extends({
    className: clsx('sovosToolbarToggle', className),
    selected: selected
  }, props));
};
SovosToolbarToggle.propTypes = {
  /**
   * Extend the class name applied to the root element
   */
  className: string,
  /**
   * Text label of the toggle
   */
  label: string.isRequired,
  /**
   * True if element state is on.
   */
  selected: bool
};
export default SovosToolbarToggle;